import React, { useEffect } from "react"; 
import { useNavigate } from "react-router-dom";
import { useSecurity } from "../../auth/registered/SEC_03_03_SecurityContext"; 

export default function SiteAdminDashboard() {
  const navigate = useNavigate();
  const { roles, matrix, isGlobalAdmin, can, hasCapability } = useSecurity(); 

  useEffect(() => {
    // Maintain strict company context for tenant administration
    const currentCompany = sessionStorage.getItem("SEC_USER_COMPANY_ID");
    if (!currentCompany || currentCompany.includes("TEMP_FRIG")) {
      sessionStorage.setItem("SEC_USER_COMPANY_ID", "7f3a1c84-9d0b-4e2e-8a5f-6b2c4d3e1f0a");
    }
    
    // 🚀 FULL SECURITY DIAGNOSTICS PRESERVED
    console.group("🚀 DASHBOARD SECURITY DEBUG");
    console.log("1. Roles in Context:", roles);
    console.log("2. Matrix Rows:", matrix?.length || 0);
    console.log("3. Is Global Admin:", isGlobalAdmin);
    console.log("4. Can Sync Taxonomy?:", can("READ", "ESRS_SYNC")); 
    console.groupEnd();
  }, [roles, matrix, isGlobalAdmin, can]);
  
  // Site Administration is deliberately kept to platform-level concerns only.
  // Everything to do with authoring a report now lives under "Report Management"
  // (a card on the Registered dashboard -> report_management/ReportManagementHub).
  const adminTools = [
    {
      name: "Security Matrix",
      icon: "/icons/2D2C31_user-writer.png",
      // 🎯 PIVOT: Now pointing to the NEW Security Portal route
      path: "/registered/site-admin/security-portal",
      description: "Manage permissions and assign roles to tenant users."
    },
    {
      name: "Knowledge Base",
      icon: "/icons/2D2C31_document.png",
      path: "/registered/site-admin/knowledge-base",
      description: "Register the procedures, policies and records the platform may draw on. Each document is split into passages for retrieval and citation.",
      requiresCapability: "KBADMIN"
    },
    {
      name: "XBRL Processor",
      icon: "/icons/2D2C31_document.png",
      path: "/registered/site-admin/xbrl-processor",
      description: "Ingest a real XBRL taxonomy package via the AWS Lambda processor. Declaring, using and versioning a taxonomy is coming next."
    }
  ];

  return (
    <main id="main" className="page-main" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section">
          <div className="container mt-4">
            
            {/* Header Section */}
            <div className="row mb-4">
              <div className="col">
                <h2 className="h4 fw-bold">Site Administration</h2>
                <p className="text-muted small">
                  Dedicated Channel: <span className="badge bg-light text-dark border">{process.env.REACT_APP_SITE_KEY}</span>
                </p>
              </div>
            </div>

            {/* Admin Tools Grid */}
            <div className="row g-4">
              {adminTools.filter((t) => !t.requiresCapability || hasCapability(t.requiresCapability)).map((tool, index) => (
                <div key={index} className="col-12 col-sm-6 col-md-4">
                  <div
                    className="card h-100 text-center shadow-sm border dashboard-card"
                    onClick={() => navigate(tool.path)}
                    style={{ cursor: "pointer", transition: "transform 0.2s" }}
                  >
                    <div className="card-body d-flex flex-column align-items-center justify-content-center py-4">
                      {tool.legacy && (
                        <span className="badge bg-warning text-dark mb-2">Legacy POC</span>
                      )}
                      <img
                        src={tool.icon}
                        alt=""
                        className="mb-3"
                        style={{ width: "64px", height: "64px", objectFit: "contain" }}
                      />
                      <h6 className="card-title mb-1 fw-bold">{tool.name}</h6>
                      <p className="text-muted small mb-0 px-2">{tool.description}</p>
                      {tool.legacy && (
                        <p className="text-warning small fw-bold mb-0 px-2 mt-2">{tool.legacyNote}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer Navigation */}
            <div className="mt-5 border-top pt-3">
               <button 
                 className="btn btn-link text-decoration-none p-0 text-secondary small" 
                 onClick={() => navigate("/registered/dashboard")}
               >
                  &larr; Return to Registered Dashboard
               </button>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}